import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

export default class TextAlignment extends BaseOption {
  static userInterfaceComponent = {
    label: "Content Alignment",
    component: inspectorTools.RADIO_BAR,
    props: {
      options: [
        {
          value: "left",
          label: "Left",
        },
        {
          value: "center",
          label: "Center",
        },
        {
          value: "right",
          label: "Right",
        },
      ],
    },
  };

  static defaultValue = "center";
}
